const R = require('ramda')
const orgEntityFuture = require('./org-entity-future')
const httpFuture = require('../lib/http-future')
const adjustVehicle = require('../lib/adjust-vehicle')

const fieldRequests = orgEntityFuture('field')

fieldRequests.getStandardFields = (org) => httpFuture.get('/standardfields')
  .map(R.path([ 'body', 'fields' ]))
  .map(adjustVehicle(R.defaultTo({}, R.path([ 'settings', 'vehicles' ], org))))

module.exports = fieldRequests
